import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class CmsStudioService {  
  constructor(private http: HttpClient) { }

 //public apiHost = "http://localhost:7071";
  // public masterKey = "";
  public apiHost = "https://cmsdd.azurewebsites.net";
  public masterKey = "?code=GU9ijXNkzvpgU9MmsW8bXYhCQO/aaTzCJgTGekRnHevSaJYys78htw==";
  // public apiHost = "https://cmsstudiodd.azurewebsites.net";
  // public masterKey = "?code=Gi4uoFGxHFcmcn8e2pRrmPo1lVz1fNaLobJ2LRMr9LjxAXF3ygjMHg==";

  //public companyCode = 1;
  public companyCodeAU = '1';
  public companyCodeNZ = 'L02';

  private handleError(error: any) {
    console.error('post error:', error);
    return Observable.throw(error.statusText);
  }

  /* getAllActiveSelectorKeys(){
     var options = new RequestOptions({
       headers: new Headers({
         'Access-Control-Cross-Origin': '*',
         'Access-Control-Allow-Origin': '*' 
       })
     });
     
     return this.http.get(this.apiHost + '/api/getallactiveselectorkeys' + this.masterKey, options)
       .map(res => res())
       .catch(this.handleError);
   }
 
   addNewSelector(selectorId){
     let input = new FormData();
     input.append("selectorId", selectorId);
     
     var options = new RequestOptions({
       headers: new Headers({
         'Access-Control-Cross-Origin': '*'
       })
     });
 
     return this.http.post(this.apiHost + '/api/addnewselector' + this.masterKey, input, options)
       .map(res => res())
       .catch(this.handleError);
   }
 
   getCmsForSelectorKey(selectorId){
     var options = new RequestOptions({
       headers: new Headers({
         'Access-Control-Cross-Origin': '*',
         'Access-Control-Allow-Origin': '*'
       })
     });
     
     return this.http.get(this.apiHost + '/api/getcmsforselectorkey/' + selectorId + this.masterKey, options)
       .map(res => res())
       .catch(this.handleError);
   }*/

  getAllActiveCategories() {
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');
    return this.http.get(this.apiHost + '/api/getallactivecategories' + this.masterKey, {'headers': headers})
    .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  getAllActiveCms(companyCode = "DDL") {
    if (companyCode == 'T01'){ 
      companyCode = this.companyCodeAU; 
    }
    else if(companyCode == 'T02'){
      companyCode = this.companyCodeNZ; 
    }
    
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');
    return this.http.get(this.apiHost + '/api/getallactivecms/' + companyCode + this.masterKey, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  getAllCms(companyCode = "DDL") {
    if (companyCode == 'T01'){ 
      companyCode = this.companyCodeAU; 
    }
    else if(companyCode == 'T02'){
      companyCode = this.companyCodeNZ; 
    }
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');
    return this.http.get(this.apiHost + '/api/getallcms/' + companyCode + this.masterKey, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  getCmsHomePage(companyCode = "DDL") {
    if (companyCode == 'T01'){ 
      companyCode = this.companyCodeAU; 
    }
    else if(companyCode == 'T02'){
      companyCode = this.companyCodeNZ; 
    }
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');
    return this.http.get(this.apiHost + '/api/getcmshomepage/' + companyCode + this.masterKey, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  getCmsForCategoryPath(categoryPath) {
    let input = new FormData();
    input.append("categoryPath", categoryPath);

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');

    return this.http.post(this.apiHost + '/api/getcmsforcategorypath' + this.masterKey, input, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  getCmsForTag(tag) {
    let input = new FormData();
    input.append("tag", tag);

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');

    return this.http.post(this.apiHost + '/api/getcmsfortag' + this.masterKey, input, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  createOrUpdateCms(cms) {
    //delete cms._id;
    let input = new FormData();
    var cmsJsonString = JSON.stringify(cms);
    input.append("cms", cmsJsonString);

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    return this.http.post(this.apiHost + '/api/createorupdatecms' + this.masterKey, input, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  createOrUpdateCategory(category) {
    //delete cms._id;
    let input = new FormData();
    input.append("category", JSON.stringify(category));

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    return this.http.post(this.apiHost + '/api/createorupdatecategory' + this.masterKey, input, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  getCmsById(id) {
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');

    return this.http.get(this.apiHost + '/api/getcmsbyid/' + id + this.masterKey, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  /*searchTemplates(searchterm) {    
    var options = {
      headers: new HttpHeaders({
        'Access-Control-Cross-Origin': '*',
        'Access-Control-Allow-Origin': '*'
      })
    };

    return this.http.get(this.apiHost + '/api/searchcmstemplates/' + searchterm + this.masterKey, options)
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }*/

  searchCmsByTitle(searchterm, companyCode = "DDL") {
    if (companyCode == 'T01'){ 
      companyCode = this.companyCodeAU; 
    }
    else if(companyCode == 'T02'){
      companyCode = this.companyCodeNZ; 
    }
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');

    return this.http.get(this.apiHost + '/api/searchcmsbytitle/' + companyCode + "/" + searchterm + this.masterKey, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  deleteCmsById(cmsid) {
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');

    return this.http.get(this.apiHost + '/api/deletecmsbyid/' + cmsid + this.masterKey, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  getAllActiveMasterCms(companyCode = "DDL") {
    if (companyCode == 'T01'){ 
      companyCode = this.companyCodeAU; 
    }
    else if(companyCode == 'T02'){
      companyCode = this.companyCodeNZ; 
    }
    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    headers = headers.append('Access-Control-Allow-Origin','*');

    return this.http.get(this.apiHost + '/api/getallactivemastercms/' + companyCode + this.masterKey, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }

  updateCmsBatch(event: any, cmsid) {
    let input = new FormData();
    input.append("category", JSON.stringify(event));
    input.append("cmsid", cmsid);

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Cross-Origin','*');
    return this.http.post(this.apiHost + '/api/updatecmsbatch' + this.masterKey, input, {'headers': headers})
      .pipe(map((res:any)=> res),catchError(this.handleError));
  }
}
